
import { Localizzazione } from './localizzazione';
import { Category } from './category';
import { Itinerario } from './itinerario';
import { ElencoItinerari } from './elenco-itinerari';


export class ItinerarioSummary {

  category:        Category;
  elenco:     Array<Itinerario>;
}
